<template>
    <rkm-modal
        :buttons="['cancel']"
        extra-large
        ref="Modal"
        title="Agendamentos e demandas"
    >
        <rkm-form
            v-if="loaded"
            ref="Form"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-date-picker
                        :end-validations="validations.periodo"
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="form.origens"
                        @change="handleOrigemChange"
                        default-option-text="Todas"
                        label="Origem do atendimento"
                        show-default-option
                        v-model="model.origem"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clear"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
                responsive
            />
        </rkm-area>

        <rkm-area
            v-if="totalizadores"
            no-margin-top
            title="Totais"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.agendado"
                        disabled
                        label="Agendado"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.realizado"
                        disabled
                        label="Realizado"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.reagendadoPeloPaciente"
                        disabled
                        label="Reagendado pelo paciente"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.reagendadoPeloMedico"
                        disabled
                        label="Reagendado pelo médico"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.canceladoPeloPaciente"
                        disabled
                        label="Cancelado pelo paciente"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.canceladoPeloMedico"
                        disabled
                        label="Cancelado pelo médico"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.faltaPaciente"
                        disabled
                        label="Falta do paciente"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :value="totalizadores.faltaMedico"
                        disabled
                        label="Falta do médico"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-input
                        :value="totalizadores.emAberto"
                        disabled
                        label="Em aberto"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="totalizadores.evadido"
                        disabled
                        label="Evadido"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :value="totalizadores.geral"
                        disabled
                        label="Total geral"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-modal>
</template>

<script>
// Mixins.
import { repository, error, stringCase, formats, file } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment
import moment from 'moment'

export default {
    computed: {
        validations() {
            return {
                periodo: {required: true},
            }
        },
        fields() {
            return [
                {key: 'origem', label: 'Origem do atendimento', sortable: true},
                {key: 'unidade', label: 'Unidade', sortable: true},
                {key: 'infraestrutura', label: 'Local de atendimento', sortable: true},
                {key: 'usuario', label: 'Profissional', sortable: true},
                {key: 'ocupacao', label: 'CBO', sortable: true},
                {key: 'especialidade', label: 'Especialidade', sortable: true},
                {key: 'tipo', label: 'Tipo de atendimento', sortable: true},
                {formatter: value => this.formatDate(value), filterByFormatted: true, key: 'data', label: 'Data', sortable: true},
                {key: 'horario', label: 'Hora', sortable: true},
                {key: 'status', label: 'Status', sortable: true},
                {key: 'motivoCancelamento', label: 'Motivo do cancelamento', sortable: true},
            ]
        }
    },
    created() {
        this.repositories = {
            agendamento: this.getConectaSusRepository('ambulatorio.agendamento'),
            impressao: this.getConectaSusRepository('impressao.ambulatorio')
        }
    },
    data: () => ({
        loaded: false,
        form: null,
        model: null,
        itens: [],
        totalizadores: null,
        sortBy: 'data',
        sortDesc: true,
        others: { moment },
        unwatchers: {
            unwatchPeriodo: null
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
        open() {
            this.reset()
            this.load()

            this.$refs.Modal.show()
        },
        load() {
            this.setLoading()

            this.repositories.agendamento.createAgendamentoDemandaEspontanea(this.pacienteId)
                .then(({ data }) => {
                    this.form = data.form
                    this.model = data.model

                    if (this.model.periodo.start) {
                        this.model.periodo.start = this.others.moment(this.model.periodo.start, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }

                    if (this.model.periodo.end) {
                        this.model.periodo.end = this.others.moment(this.model.periodo.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
                    }

                    this.itens = data.itens
                    this.totalizadores = data.totalizadores

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {
            this.unwatchers.unwatchPeriodo = this.$watch('model.periodo', {
                deep: true,
                handler(value) {
                    this.form.origens = []
                    this.model.origem = null

                    this.itens = []
                    this.totalizadores = null

                    if (value.start === null || value.end === null) return

                    const request = {
                        origem: 'agendamento-demanda-espontanea',
                        listar: 'origens',
                        pacienteId: this.pacienteId,
                        periodo: {
                            start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                            end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                        },
                    }

                    this.setLoading()

                    this.repositories.agendamento.list(this.camelObjectKeysToSnakeRecursive(request))
                        .then(response => {
                            this.form.origens = Object.assign(response.data.origens)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                },
            })
        },
        handleOrigemChange() {
            this.itens = []
            this.totalizadores = null
        },
        search() {
            this.setLoading()

            this.repositories.agendamento.getAgendamentosDemandasEspontaneas(this.prepareData())
                .then(({ data }) => {
                    this.itens = data.itens
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {
            return this.camelObjectKeysToSnakeRecursive({
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                origem: this.model.origem,
            })
        },
        clear() {
            this.model.periodo = { start: null, end: null }
            this.form.origens = []
            this.model.origem = null

            this.$nextTick().then(() => this.$refs.Form.resetValidator())

            this.itens = []
            this.totalizadores = null
        },
        print() {
            this.setLoading()

            this.repositories.impressao.agendamentoDemandaEspontanea(this.preparePrintData())
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        preparePrintData() {
            return this.camelObjectKeysToSnakeRecursive({
                pacienteId: this.pacienteId,
                periodo: {
                    start: this.others.moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    end: this.others.moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                origem: this.model.origem,
                sortBy: this.camelToSnake(this.sortBy),
                sortDesc: this.sortDesc,
                columns: this.fields.map(f => ({
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class
                }))
            })
        },
        reset() {
            this.loaded = false
            this.form = null
            this.model = null

            this.itens = []
            this.totalizadores = null

            if (this.unwatchers.unwatchPeriodo) {
                this.unwatchers.unwatchPeriodo()
            }
        },
    },
    mixins: [repository, error, stringCase, formats, file],
    props: {
        pacienteId: { type: Number, required: true },
    },
}
</script>